export enum Apps {
    CURRICULUM_CMS = 'curriculum-cms',
    MATHSHUB = 'mathshub',
    SCHOLA = 'schola',
    SESSION_REVIEW = 'session-review',
    STUDENT_EXPERIENCE = 'student-experience',
    TEACHER_EXPERIENCE = 'teacher-experience',
    MAIN_APP = 'main-app',
}
